import { createRouter } from "@tanstack/react-router";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { routeTree } from "./routeTree.gen";
import { ApiError, setUnauthorizedHandler } from "./api/client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 10_000, retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2 },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      if (err instanceof ApiError && err.status === 401) return;
      if (err instanceof ApiError && err.status === 403) toast.error("You do not have permission to do that");
    },
  }),
  mutationCache: new MutationCache({
    onError: (err) => {
      if (err instanceof ApiError && err.status === 401) return;
      // Individual callers usually toast with context; this is the safety net.
      if (!(err instanceof ApiError) || err.status >= 500) toast.error(err.message || "Request failed");
    },
  }),
});

export interface RouterContext {
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

setUnauthorizedHandler(() => {
  queryClient.clear();
  const here = window.location.pathname + window.location.search;
  if (!here.startsWith("/login") && !here.startsWith("/auth/")) {
    router.navigate({ to: "/login", search: { redirect: here } });
  }
});
